import React from 'react'
import PropTypes from 'prop-types'

function TabletSidebarMenuItem (props) {
  const classNames = [
    'items-center',
    'py-3',
    'px-2',
    'text-xs',
    'leading-4',
    'font-regular',
    'hover:text-white',
    'hover:bg-primary-400',
    'focus:outline-none',
    'transition',
    'ease-in-out',
    'duration-150',
    'cursor-pointer',
    'w-full',
    'relative'
  ]

  if (props.active === true) {
    classNames.push('text-white')
    classNames.push('bg-primary-500')
  } else {
    classNames.push('text-gray-500')
  }

  const icon = props.svgIcon ? (<div className='w-6 h-6 mx-auto'>{props.svgIcon}</div>) : null

  return (
    <div onClick={props.onClick} className={classNames.join(' ')}>
      {icon}
      <div className='text-center mt-2'>{props.text}</div>
    </div>
  )
}

TabletSidebarMenuItem.defaultProps = {
  active: false
}

TabletSidebarMenuItem.propTypes = {
  active: PropTypes.bool,
  text: PropTypes.node,
  svgIcon: PropTypes.node
}

export default TabletSidebarMenuItem
